export default function deleteDocument(ref) {
	return ref.delete();
}
